<div class="flex flex-col -m-6">
  <!-- Header -->
  <div class="flex flex-row flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="grid grid-cols-9 items-center">
      <div class="col-start-1 col-span-3 items-center text-lg font-medium">
        {{ 'missionUserEvents.userEvents' | transloco}} {{ data?.user?.displayName }}
      </div>
      @if (showData) {
        <div class="flex flex-row justify-center col-start-5 col-span-3">
          <button mat-stroked-button (click)="goBack()"
            class="cursor-pointer text-white">
            {{ 'missionUserEvents.goBack' | transloco}}
          </button>
          <button mat-stroked-button (click)="showTextData = !showTextData"
            class="cursor-pointer text-white ml-3 col-start-6 col-end-3">
            @if (showTextData) {
              <span>{{ 'missionUserEvents.showTree' | transloco}}</span>
            }
            @if (!showTextData) {
              <span>{{ 'missionUserEvents.showTextFormat' | transloco}}</span>
            }
          </button>
        </div>
      }
      @if (!showData) {
        <div class="flex flex-row justify-center col-start-5 col-span-2">
          <!-- Start Date -->
          <mat-form-field class="flex flex-col w-full items-center mt-6">
            <input matInput [formControl]="searchControl"
              [placeholder]="'missionUserEvents.searchRequest' | transloco">
            </mat-form-field>
          </div>
        }
        @if (!showData) {
          <div class="flex flex-row justify-center col-start-7 col-span-1">
            <div class="flex flex-row ml-4 items-center">
              <mat-slide-toggle [checked]="errorsOnly" (change)="toggleErrorsOnly()" color="primary"></mat-slide-toggle>
              <span>{{ 'missionUserEvents.errorsOnly' | transloco}}</span>
            </div>
          </div>
        }
        <div class="flex col-start-8 col-end-auto">
          <div class="flex p-4">
            <!-- Start Date -->
            <div class="flex flex-row">
              <mat-form-field class="flex flex-col w-full items-center cursor-pointer">
                <mat-label>''</mat-label>
                <input readonly matInput [formControl]="date"
                  [max]="today"
                  [matDatepicker]="datepicker"
                  (click)="openDatepickerOnClick(datepicker)"
                  [placeholder]="'startDatePlaceholder' | transloco">
                  <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker [startView]="'month'"></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="flex justify-end items-end col-start-9">
            <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
              <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="flex flex-row text-md w-full p-6">
        <!-- Events -->
        @if (!showData) {
          <div class="flex flex-col w-full">
            <div class="grid">
              <!-- Header -->
                <div class="events-grid z-10 text-md sticky top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
                            bg-gray-50 dark:bg-slate-900">
                <!-- Application Uri -->
                <div class="flex items-center">
                  {{ 'missionUserEvents.applicationUri' | transloco}}
                </div>
                <!-- Inner Response Code -->
                <div class="flex items-center">
                  {{ 'missionUserEvents.innerResponse' | transloco}}
                </div>
                <!-- Ms -->
                <!-- <div class="flex items-center">
                {{ 'missionUserEvents.ms' | transloco}}
              </div> -->
              <!-- Timestamp -->
              <div class="flex items-center">
                {{ 'missionUserEvents.timestamp' | transloco}}
              </div>
              <!-- Requested Url -->
              <div class="flex items-center">
                {{ 'missionUserEvents.requestedUrl' | transloco}}
              </div>
              <!-- Request -->
              <div class="flex items-center">
                {{ 'missionUserEvents.request' | transloco}}
              </div>
              <!-- Response Code -->
              <div class="flex items-center">
                {{ 'missionUserEvents.responseCode' | transloco}}
              </div>
              <!-- Response -->
              <div class="flex items-center">
                {{ 'missionUserEvents.response' | transloco}}
              </div>
            </div>
            <!-- Rows -->
            @for (event of eventsData?.logs; track event; let i = $index) {
              <div [ngClass]="{'bg-red-300': logHasError(event)}" class="events-grid grid gap-4 py-3 px-4 sm:px-6 border-b">
                <!-- Application Uri -->
                <div class="truncate flex items-center">
                  {{ event?.applicationUri }}
                </div>
                <!-- Inner Response -->
                <div class="flex items-center">
                  @if (event?.hasInnerResponse) {
                    <button mat-icon-button (click)="showInnerResponseEvent(event)"
                      class="cursor-pointer">
                      <mat-icon class="icon-size-5" svgIcon="heroicons_solid:eye"></mat-icon>
                    </button>
                  }
                </div>
                <!-- Ms -->
                <!-- <div class="flex items-center">
                {{ event?.ms }} ms
              </div> -->
              <!-- Timestamp -->
              <div class="flex items-center">
                {{ $safeNavigationMigration(event?.timestamp) | localizeDate:'dd/MM/yyyy HH:mm' }}
              </div>
              <!-- Requested Url -->
              <div class="truncate flex items-center" [matTooltip]="event?.requestedUrl.length > 28 ? $safeNavigationMigration(event?.requestedUrl) : null">
                {{ event?.requestedUrl  }}
              </div>
              <!-- Request -->
              <div class="flex items-center">
                @if (event?.hasRequest) {
                  <button mat-icon-button (click)="showRequestEvent(event)"
                    class="cursor-pointer">
                    <mat-icon class="icon-size-5" svgIcon="heroicons_solid:eye"></mat-icon>
                  </button>
                }
              </div>
              <!-- Response Code -->
              <div class="flex items-center">
                {{ event?.responseCode  }}
              </div>
              <!--Response-->
              <div class="flex items-center">
                @if (event?.hasResponse) {
                  <button mat-icon-button (click)="showResponseEvent(event)"
                    class="cursor-pointer">
                    <mat-icon class="icon-size-5" svgIcon="heroicons_solid:eye"></mat-icon>
                  </button>
                }
              </div>
            </div>
          }
          <ng-container>
            @if (!eventsData?.logs) {
              <div class="flex flex-row justify-center text-center items-center m-3 text-xl">
                {{ 'missionUserEvents.noLogs' | transloco}} {{ data?.user?.displayName }}
              </div>
            }
            @if (eventsData?.logs?.length === 0) {
              <div class="flex flex-row justify-center text-center items-center m-3 text-xl">
                {{ 'missionUserEvents.noLogsWithFilters' | transloco}} {{ data?.user?.displayName }}
              </div>
            }
          </ng-container>
        </div>
      </div>
    }
    @if (showData) {
      <div class="flex flex-col w-full">
        @if (showTextData) {
          <textarea autosize matInput [formControl]="dataControl" [readonly]="true"></textarea>
        }
        @if (!showTextData) {
          <dynamic-tree [data]="dataToPrint"></dynamic-tree>
        }
      </div>
    }
  </div>
</div>